export const TATA_TELE_NUMBER1 = "080-69181088"
export const TATA_TELE_NUMBER2 = "080-69181089"
